package com.hyperether.goodjob.scenes.components

fun toggleSelection(selected: Set<String>, option: String): Set<String> {
    return if (selected.contains(option)) {
        selected - option // Deselect if it's already selected
    } else {
        selected + option // Select if it's not already selected
    }
}